import React from 'react';
import PropTypes from 'prop-types';
import Banner from 'components/Banner.jsx';
import { Button, Modal } from 'components/ui';
import DocumentsToSignModal from 'components/Documents/DocumentsToSignModal.jsx';
import { userSelector, imperativeEditUser } from 'modules/currentUser';
import { useSelector, useDispatch } from 'react-redux';
import Backbone from 'backbone';
import useI18n from 'hooks/I18n/useI18n.js';
import { isProfessional } from 'models/users.js';
import * as R from 'ramda';

const BannerContainer = ({ type }) => {
    const { trans, i18n } = useI18n();
    const user = useSelector(userSelector);
    const dispatch = useDispatch();
    const isConnectionError = type === 'connectionError';
    const isAccountSettingsPath =
        `/${i18n}/configuration/account/identity` === window.location.pathname;

    if ((!user && !isConnectionError) || user.anonymous) {
        return null;
    }

    if (isConnectionError) {
        const refresh = () => {
            Backbone.history.loadUrl();
        };
        return (
            <Banner fixed>
                {trans('connectionBanner.text')}{' '}
                <Button weight="link" className="button--noPadding" onClick={refresh}>
                    {trans('connectionBanner.action')}
                </Button>
            </Banner>
        );
    } else if (
        (!user.hasAcceptedTOS && !isAccountSettingsPath) ||
        (!user.hasAcceptedSCU && isProfessional(user))
    ) {
        const validateDocumentsOnModel = () => {
            dispatch(
                imperativeEditUser(
                    R.evolve({
                        hasAcceptedTOS: R.T,
                    })
                )
            );

            if (isProfessional(user)) {
                dispatch(
                    imperativeEditUser(
                        R.evolve({
                            hasAcceptedSCU: R.T,
                        })
                    )
                );
            }
        };
        const userShouldSeeCommissionBEFRMCPFModal =
            ['BE', 'FR', 'MC', 'PF'].indexOf(R.path(['address', 'country', 'code'], user)) !== -1;

        return (
            <Modal isOpened isBlocking closeModal={() => {}}>
                <DocumentsToSignModal
                    i18n={window.language}
                    hasAcceptedTOS={user.hasAcceptedTOS}
                    hasAcceptedSCU={user.hasAcceptedSCU}
                    userId={user.id}
                    isProfessional={isProfessional(user)}
                    validateDocumentsOnModel={validateDocumentsOnModel}
                    variant={
                        !isProfessional(user) || userShouldSeeCommissionBEFRMCPFModal
                            ? 'commissions_be_fr_mc_pf'
                            : 'legacy'
                    }
                />
            </Modal>
        );
    }

    return null;
};

BannerContainer.propTypes = {
    type: PropTypes.string,
};

export default BannerContainer;
